export const LOADING_START = (state) => {
  state.loading = true
}

export const LOADING_DONE = (state) => {
  state.loading = false
}

export const SAVE_ROOT_DATA = (state, data) => {
  if (data.children && data.children.length > 0) {
    state.rootData = data
  }
}

export const SAVE_OPEN_BRANCH = (state, id) => {
  let idx = state.open.indexOf(id)
  if (idx === -1) {
    state.open.push(id)
  }
}

export const REMOVE_OPEN_BRANCH = (state, id) => {
  let idx = state.open.indexOf(id)
  if (idx > -1) {
    state.open.splice(idx, 1)
  }
}

export const RESET = (state) => {
  state.selected = {
    id: 1,
    name: 'Universität Leipzig'
  }
}

export const SAVE_BRANCH_DATA = (state, treeItemData) => {
  state.branch[treeItemData.id] = treeItemData
}

export const SELECT_BRANCH = (state, branch) => {
  if (branch && branch.id && branch.id > -1) {
    state.selected = branch
  }
}

export const SET_LOADING = (state, bool) => {
  if (bool === true) {
    state.loading = true
  } else {
    // all other value leads to false
    state.loading = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tree/mutations.js